const KEYWORDS_BY_LOCALE: Record<string, string[]> = {
  "pt-BR": ["tchau", "adeus", "até logo", "até mais", "falou", "até breve", "boa noite"],
};

export function goodbyeKeywordsForLocale(targetLocale: string): string[] {
  return KEYWORDS_BY_LOCALE[targetLocale] ?? [];
}
